import React, { FC, forwardRef } from 'react';
import MuiTab from '@material-ui/core/Tab';
import { TabProps } from './types';
import useStyles from './styles';

const Tab: FC<TabProps> = forwardRef(({
  label,
  disabled,
  icon,
  value,
  ...restProps
}, ref) => {
  const classes = useStyles();
  return (
    <MuiTab
      ref={ref}
      classes={classes}
      label={label}
      disabled={disabled}
      icon={icon}
      value={value}
      {...restProps}
    />
  );
});

export default Tab;
